import React from "react";
import Workshops from "../sections/Workshops.jsx";
export default function PageWorkshops() { return <Workshops />; }
